import React from 'react'
import classes from "./eleg.module.css";
import Fade from "react-reveal/Fade"

import a from './../../Assest/a1.png';
import b from './../../Assest/a2.png';
import c from './../../Assest/a3.png';
import d from './../../Assest/a4.png';
import z from './../../Assest/ss1.jpeg'

const eleg = () => {
  return (
    <div>

<div className={classes.steps}>

<div className={classes.steps0}><Fade left >
<div className={classes.d1}>
  <h2 className={classes.ih4}>RUSHIKESH CAREER GUIDANCE</h2>
  <p className={classes.ih41}>Rushikesh Career Guidance (RCG) is a professional career and admission counselling firm based in Pune, serving students across India.

Founded by Rushikesh Sir, RCG focuses on honest, transparent and student-centric guidance for NEET, Engineering, MBA and Abroad admissions. With hands-on counselling experience and deep understanding of AIQ and State counselling processes, we support students and parents from form filling to final admission.Our goal is simple – to reduce confusion, prevent wrong decisions and help students choose the right career path with confidence.
</p>
</div>
</Fade>
<Fade right >
<div className={classes.d2}><a href="https://youtu.be/vIIq-nrR2Xo?si=OrHDj2XCsv8q259Q"> <img src={z} className={classes.d2z} ></img></a></div></Fade>
</div>


<div className={classes.steps1}>
  <Fade left >
<div className={classes.st1}>
  <img src={a} className={classes.imgs} />
  <h5 className={classes.ih3}>Experienced Advisors</h5>
  <h6 className={classes.ih31}>
    Our counselors are dedicated to assisting you in investigating possibilities, and confidently achieving your career objectives.
  </h6>
</div></Fade>
  <Fade left >
<div className={classes.st1}>
  <img src={b} className={classes.imgs} />
  <h5 className={classes.ih3}>Detailed Admissions Support</h5>
  <h6 className={classes.ih31}>
    With our thorough study and professional admission advice, you can secure your spot in reputable institutions.
  </h6>
</div>
</Fade>
  <Fade right >
<div className={classes.st1}>
  <img src={c} className={classes.imgs} />
  <h5 className={classes.ih3}>Full Admission Assistance</h5>
  <h6 className={classes.ih31}>
Our committed staff offers individualized assistance and knowledgeable counsel to ensure your admission success.  </h6>
</div></Fade>
<Fade right >
<div className={classes.st1}>
  <img src={d} className={classes.imgs4} />
  <h5 className={classes.ih3}>24/7 Technical Support</h5>
  <h6 className={classes.ih31}>
    Our dedicated support team is available around the clock to assist you with any issues or questions you may have.
  </h6>
</div></Fade>
</div>



</div>

    </div>
  )
}

export default eleg